import React from 'react';
import { Login, LoginForm } from 'react-admin';
import { ThemeProvider } from '@material-ui/core';
import { theme } from '../theme';

export const CustomLoginPage = () => (
	<ThemeProvider theme={theme}>
		<div>
			<Login
				className="CustomLoginPage"
				title={'FitTech | Admin Panel'}
				backgroundImage="assets/login-background.jpg"
			>
				<LoginForm>
				</LoginForm>
			</Login>
		</div>
	</ThemeProvider>
);
